import { TestIds } from './form'

export enum PRIVACY_POLICY_CONFIGURATIONS {
	DEFAULT = 'DEFAULT',
	DISABLED = 'DISABLED',
	/** Privacy policy for USA */
	VARIATION_1 = 'VARIATION_1',
	/** Privacy policy for Korea */
	VARIATION_2 = 'VARIATION_2',
	/** Privacy policy for Turkey */
	VARIATION_3 = 'VARIATION_3',
}

export const PRIVACY_TEST_IDS: Record<
	PRIVACY_POLICY_CONFIGURATIONS,
	string | undefined
> = {
	[PRIVACY_POLICY_CONFIGURATIONS.DEFAULT]: TestIds.PrivacyPolicyDefault,
	[PRIVACY_POLICY_CONFIGURATIONS.DISABLED]: undefined,
	[PRIVACY_POLICY_CONFIGURATIONS.VARIATION_1]: TestIds.PrivacyPolicyInsideForm,
	[PRIVACY_POLICY_CONFIGURATIONS.VARIATION_2]: TestIds.LegalConfirmation,
	[PRIVACY_POLICY_CONFIGURATIONS.VARIATION_3]: TestIds.LegalConfirmationPdf,
}
